import { ApiObjectHandler } from './abstract-handler';

import * as Types from '../../../types';

export class DomainHandler extends ApiObjectHandler<Types.DomainApi.Domain> {}
